// Servicio para monitorear el estado de conexión a MySQL
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

export interface MySQLStatus {
  connected: boolean;
  status: 'connected' | 'disconnected' | 'error';
  message: string;
  timestamp: Date;
}

class MySQLService {
  private static instance: MySQLService;
  private status: MySQLStatus = {
    connected: false,
    status: 'disconnected',
    message: 'Sin conexión',
    timestamp: new Date()
  };

  private constructor() {}

  public static getInstance(): MySQLService {
    if (!MySQLService.instance) {
      MySQLService.instance = new MySQLService();
    }
    return MySQLService.instance;
  }

  // Verificar el estado de la conexión a MySQL
  async checkConnection(): Promise<MySQLStatus> {
    try {
      const response = await fetch(`${API_BASE_URL}/health`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        this.status = {
          connected: true,
          status: 'connected',
          message: 'Conectado a MySQL',
          timestamp: new Date()
        };
      } else {
        this.status = {
          connected: false,
          status: 'error',
          message: 'Error en la API',
          timestamp: new Date()
        };
      }
    } catch (error) {
      this.status = {
        connected: false,
        status: 'disconnected',
        message: 'Sin conexión al servidor',
        timestamp: new Date()
      };
    }

    return this.status;
  }

  // Obtener el estado actual
  getCurrentStatus(): MySQLStatus {
    return this.status;
  }

  // Iniciar monitoreo continuo
  startMonitoring(intervalMs: number = 10000): NodeJS.Timeout {
    return setInterval(async () => {
      await this.checkConnection();
    }, intervalMs);
  }

  // Detener monitoreo
  stopMonitoring(intervalId: NodeJS.Timeout): void {
    clearInterval(intervalId);
  }
}

export default MySQLService; 